/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const config = {};

config.google_tag_manager = 'GTM-K2Q2F58';
config.google_tag_manager_auth = 'gNVFNcq8a8VutZQcSQZ8jg';
config.google_tag_manager_preview = 'env-2';
config.google_tag_manager_cookies_win = 'x';
config.adobe_analytics = false;
config.hotjar = { hjid: 2612638, hjsv: 6 };
config.cookie_first = 'a6946219-3a42-4676-8c2a-d933e05ce061';

export default config;
